import { UPDATETSTEMPLATE_SUCCESS, UPDATETSTEMPLATE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const updateTsTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATETSTEMPLATE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATETSTEMPLATE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateTsTemplateReducer;
